import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ContentService } from '../../_core';
import { LcpHelper } from '../../_core/_helpers/lcp-helper';
// import { TypeJobListingFields } from '../content-types';
// import { Entry } from 'contentful';

// import { faBars } from '@fortawesome/free-solid-svg-icons';



// https://stackoverflow.com/questions/70442770/infinite-scrolling-carousel-css-only

@Component({
  selector: 'lcp-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss']
})
export class CarouselComponent implements OnInit {

  @Input('media') mediaIn: any[] = []
  @Input('items') itemsIn: any[] = []
  @Input('options') options: any = {}
  @Input('direction') direction: string = 'left'
  @Input('slideCount') slideCount: number = 16

  @Output() onInit = new EventEmitter<any>()

  media: any[]
  items: any[]

  navItems: any
  containerClass: string

  // faBars = faBars

  shouldShowMenu: boolean = false

  hoveringContainer: boolean
  hoveringSlide: boolean
  isPaused: boolean = false


  // NOTE: KEEP UTD w/ CSS.
  // $carousel-no-of-slides: 16;
  // slideCount = 16

  // srcArray = [
  //   'https://picsum.photos/seed/1/200/300',
  //   'https://picsum.photos/seed/2/200/300',
  //   'https://picsum.photos/seed/3/200/300',
  //   'https://picsum.photos/seed/4/200/300',
  //   'https://picsum.photos/seed/5/200/300',
  //   'https://picsum.photos/seed/6/200/300',
  // ]

  // carouselArray1: any[]
  // carouselArray2: any[]

  constructor(
    private cdr: ChangeDetectorRef,
    public contentService: ContentService,
    public lcpHelper: LcpHelper
  ) { }

  ngOnInit() {
    // console.log('TODO: init carousel')
    this.onInit.emit(this.slideCount)
    // this.getMainNavItems()
    this.updateMedia()
    this.updateItems()
    this.update()
  }

  ngOnChanges(changes) {
    // console.log('changes', changes)
    if ([8, 23].indexOf(this.slideCount) < 0) console.warn("WARNING (lcp): carousel is only ready for 6 or 16 slides")

    if (changes['itemsIn']) this.updateItems()
    if (changes['media']) this.updateMedia()
    this.update()
  }
  
  count() {
    return this.slideCount 
  }

  updateMedia() {
    // console.log('updateMedia', this.mediaIn)
    if (!this.mediaIn || this.mediaIn.length == 0) return
    this.media =  this.mediaIn.slice(0, this.slideCount)
    this.detectChanges()

  }
  updateItems() {
    if (!this.itemsIn || this.itemsIn.length == 0) return // console.log('items', this.items)
    this.items =  this.itemsIn.slice(0, this.slideCount)
    this.detectChanges()
  }

  update () {
    this.isPaused = this.hoveringContainer || this.hoveringSlide
    // if ([6, 16].indexOf(this.slideCount) < 0) console.warn("WARNING (lcp): carousel is only ready for 6 or 16 slides")

    this.containerClass = 'slide-count-' + this.slideCount
    // console.log('paused', this.isPaused)
    this.detectChanges()
  }
  
  handleMouseoverContainer(evt: any) {
    // this.isPaused = true
    // evt.stopPropagation()
    // console.log('mover')
    this.hoveringContainer = true
    this.update()
  }

  handleMouseoutContainer(evt: any) {
    this.hoveringContainer = false
    this.update()
    // this.isPaused = false
    // console.log('mout', evt)
  }

  handleMouseoverSlide(evt: any) {
    // this.isPaused = true
    // evt.stopPropagation()
    // console.log('mover')
    this.hoveringSlide = true
    this.update()
  }

  handleMouseoutSlide(evt: any) {
    this.hoveringSlide = false
    this.update()
    // this.isPaused = false
    // console.log('mout', evt)
  }

  handleSelectItem(item: any) {
    // console.log('handleSelectItem', item.fields['linkAddress'], item.fields['linkText'], item)
    // lcpHelper.srcFromMedia(item.fields['media'][0])
  }


  // update() {
  //   this.carouselArray1 = this.media.slice(6, 0)
  //   this.carouselArray2 = this.media.slice(6, 6)
  // }

  // getMainNavItems() {
  //   this.contentService.getMainNavItems()
  //   .subscribe({
  //     next: (navItems) => {
  //       let results = navItems.items
  //       this.navItems = results[0].fields['items']
  //       console.log('navItems:', this.navItems)
  //     }
  //  })
  // }


  detectChanges() {
    if (!this.cdr['destroyed']) this.cdr.detectChanges()
  }
  
}
